import type { TWorkflowMoveTo } from '@data/constants/moveToValues'
import { moveToValues } from '@data/constants/moveToValues'
import { ObjectSchema, boolean, mixed, object, string } from 'yup'

const schema: ObjectSchema<TWorkflowData> = object<TWorkflowData>()
    .shape({
        canAccess: boolean().required().strict(),
        moveTo: mixed<TWorkflowMoveTo>().oneOf(moveToValues).nullable().default(null),
        uniqueId: string().required().strict(),
    })
    .transform((value) => {
        if (value?._embedded?.workflow) {
            return { ...value?._embedded?.workflow }
        }
        return value
    })
    .noUnknown()

export default schema

export const toWorkflowData = (data: unknown): TWorkflowData => {
    return schema.validateSync(data)
}
